export const colors = {
  darkGreen: 'hsl(133, 39%, 34%)',
  mono100: 'hsl(0, 0%, 100%)',
  mono96: 'hsl(0, 0%, 96%)',
  mono87: 'hsl(0, 0%, 87%)',
  mono45: 'hsl(0, 0%, 45%)',
  orange: 'hsl(7, 86%, 57%)',
};
